import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import MUITextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockIcon from '@material-ui/icons/Lock';
import FormContext from '../FormContext';

const useStyles = makeStyles(theme => ({
  inputRoot: {
    background: theme.palette.grey[50],
    '&.Mui-disabled': {
      background: theme.palette.grey[50]
    }
  }
}));

const TextField = ({
  label,
  dataField,
  helperText,
  multiline = false,
  rows = null,
  disabled = false
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const id = `form-field/${dataField}`;
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  const value = getFieldValue(dataField);

  function getInputProps() {
    const inputProps = {
      classes: {
        root: classes.inputRoot
      }
    };
    if (disabled) {
      inputProps.endAdornment = (
        <InputAdornment position="end">
          <LockIcon />
        </InputAdornment>
      );
    }
    return inputProps;
  }

  function getLabel() {
    return label ? formatMessage({ id: label }) : label;
  }

  function getHelperText() {
    return helperText ? formatMessage({ id: helperText }) : helperText;
  }

  return (
    <MUITextField
      id={id}
      value={value}
      label={getLabel()}
      helperText={getHelperText()}
      fullWidth
      InputProps={getInputProps()}
      onChange={event => {
        setFieldValue(dataField, event.target.value);
      }}
      variant="filled"
      margin="normal"
      multiline={multiline}
      rows={rows}
      disabled={disabled}
    />
  );
};

TextField.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool
};

export default TextField;
